import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { Box, Button, Drawer, Text } from '@mantine/core';
import { memo, PropsWithChildren } from 'react';
import styled from 'styled-components';

interface Props {
	onClose: () => void;
	opened: boolean;
	position?: 'top' | 'left' | 'bottom' | 'right';
	titleText: string;
}

const InvestorDocumentsDrawer = (props: PropsWithChildren<Props>) => {
	const { onClose, opened, children, titleText, position = 'right' } = props;
	const tInvestor = useTranslationInvestor();

	return (
		<Drawer.Root
			opened={opened}
			onClose={onClose}
			position={position}
			styles={{
				content: {
					display: 'grid',
					gridTemplateRows: '4rem auto 4rem',
					gridTemplateAreas: `
                        "header"
                        "content"
                        "footer"
                    `,
					padding: '2rem',
				},
				header: {
					gridArea: 'header',
					padding: 0,
				},
				body: {
					gridArea: 'content',
					overflow: 'auto',
					padding: 0,
				},
			}}
		>
			<Drawer.Overlay />
			<Drawer.Content>
				<Drawer.Header style={{ marginBottom: '0.5rem' }}>
					<Drawer.Title>
						<Text size="B4Bold">{titleText}</Text>
					</Drawer.Title>
					<Drawer.CloseButton>
						<StyledCloseButton />
					</Drawer.CloseButton>
				</Drawer.Header>
				<Drawer.Body>{children}</Drawer.Body>
				<Box style={{ marginTop: '2rem' }}>
					<Button w="100%" className="footer" onClick={onClose}>
						{tInvestor('valuations.drawer.buttons.done')}
					</Button>
				</Box>
			</Drawer.Content>
		</Drawer.Root>
	);
};
const CloseButton = ({ className }: { className?: string }) => {
	return <div className={className}>ESC</div>;
};
const StyledCloseButton = styled(CloseButton)`
	color: ${defaultTheme.v3.colors.gray[8]};
	font-size: 0.5625rem;
	font-style: normal;
	font-weight: 600;
	line-height: 0.75rem;
	display: flex;
	width: 2rem;
	height: 1.25rem;
	padding: 0.5rem;
	justify-content: center;
	align-items: center;
	gap: 0.5rem;
	border-radius: 0.25rem;
	border: 1px solid ${defaultTheme.v3.colors.gray[8]};
`;
const _InvestorDocumentsDrawerExport = memo(InvestorDocumentsDrawer);

export { _InvestorDocumentsDrawerExport as InvestorDocumentsDrawer };
